import { keys } from '@core/Services/Analytics/keys'
import { trackEvent } from '@core/Services/Analytics/track'

export const trackSideMenuItemClick = (item: string) =>
  trackEvent(keys.hamburgerMenuClicked, { item })
